import { Cell } from '@pelckmans/elementis/components/table';

interface EmptyTableProps {
  id: string;
}

export default function EmptyTable({ id }: EmptyTableProps) {
  return (
    <table className="table" aria-labelledby={id}>
      <thead>
        <tr>
          <Cell.HeaderEmpty />
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: 8 }).map((_, index) => (
          <tr key={`row-${index}`}>
            {
              <Cell density="compact">
                <Cell.Text title="" />
              </Cell>
            }
          </tr>
        ))}
      </tbody>
    </table>
  );
}
